/* src/app/components/double-monday-component/double-monday-component.css */
ion-col {
  display: block;
}
ion-col * {
  border: 1px solid transparent;
  font-weight: bold;
  border-radius: 4px;
}
ion-col :first-child {
  color: black;
  background: cyan;
  padding: 2px;
  width: fit-content;
}
ion-col :last-child {
  margin-top: 2px;
  color: white;
  background: blue;
  padding: 2px;
  width: fit-content;
}
/*# sourceMappingURL=double-monday-component.css.map */
